{
  "loggedOut": "Bạn đã đăng xuất",
  "sessionExpired": "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.",
  "sessionInvalid": "Phiên không hợp lệ. Vui lòng đăng nhập lại.",
  "sessionValidationFailed": "Phiên không hợp lệ. Vui lòng đăng nhập lại.",
  "loadUserError": "Lỗi khi tải thông tin người dùng",
  "loginSuccess": "Xin chào {{name}}.",
  "loginFailed": "Đăng nhập thất bại",
  "errors": {
    "invalidCredentials": "Tên đăng nhập hoặc mật khẩu không đúng",
    "accountLocked": "Tài khoản tạm khóa do đăng nhập sai nhiều lần. Thử lại sau.",
    "accountInactive": "Tài khoản đã bị vô hiệu hóa. Liên hệ quản trị viên.",
    "orgInactive": "Tổ chức tạm ngưng. Liên hệ quản trị viên.",
    "tooManyRequests": "Quá nhiều lần thử. Vui lòng thử lại sau.",
    "invalid2faCode": "Mã xác minh không đúng",
    "invalid2faChallenge": "Phiên xác minh 2FA đã hết hạn. Vui lòng đăng nhập lại.",
    "ipNotAllowed": "Địa chỉ IP của bạn không được phép truy cập hệ thống.",
    "generic": "Đăng nhập thất bại. Vui lòng thử lại."
  },
  "idleLoggedOut": "Bạn đã bị đăng xuất do không thao tác trong thời gian quy định.",
  "profileUpdated": "Cập nhật hồ sơ thành công!",
  "profileUpdateFailed": "Cập nhật hồ sơ thất bại",
  "passwordUpdated": "Cập nhật mật khẩu thành công!",
  "passwordUpdateFailed": "Cập nhật mật khẩu thất bại",
  "resetEmailSent": "Đã gửi email đặt lại mật khẩu!",
  "resetEmailFailed": "Gửi email đặt lại mật khẩu thất bại",
  "passwordReset": "Đặt lại mật khẩu thành công!",
  "passwordResetFailed": "Đặt lại mật khẩu thất bại"
}
